import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { CircularProgress } from '@material-ui/core'

import CustomizedSnackbars from './Components/UI/CustomizedSnackbars'
import AuthModule from './AuthModule'
import { bindRouter } from './navigation'
import store from './Store'
import persistor from './Store/persistStorage'
import App from './App'


import { LoadScript } from '@react-google-maps/api';

const auth = new AuthModule(store)
const libraries = ['places']

// App renders its own <Routes>, so it owns everything under "/".
const router = createBrowserRouter([
  {
    path: '/*',
    element: (
      <LoadScript googleMapsApiKey={`${process.env.REACT_APP_PLACES_KEY}`} libraries={libraries}>
        <App auth={auth} />
      </LoadScript>
    ),
  },
])

// Lets sagas and other non-React code navigate through src/navigation.js.
bindRouter(router)

export const makeMainRoutes = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<CircularProgress />} persistor={persistor}>
        <RouterProvider router={router} />

        <CustomizedSnackbars />
      </PersistGate>
    </Provider>
  )
}
